import { useNavigate } from "react-router-dom";
import { useAuth } from "@tellescope/tanstack-query";
import { MFAPage } from "./MFAPage";
import { MOBILE_RETURN_SCHEME_KEY, MOBILE_AUTH_TOKEN_KEY } from "./useMobileAppLogin";
import { isAllowedMobileReturnScheme } from "./mobileReturnScheme";

export const MobileMFAPage = () => {
  const { session } = useAuth();
  const navigate = useNavigate();

  const handleSuccess = () => {
    const returnScheme = sessionStorage.getItem(MOBILE_RETURN_SCHEME_KEY) ?? "";
    if (returnScheme && isAllowedMobileReturnScheme(returnScheme) && session.authToken) {
      sessionStorage.setItem(MOBILE_AUTH_TOKEN_KEY, session.authToken);
      navigate("/mobile-app/success", { replace: true });
    } else {
      sessionStorage.removeItem(MOBILE_RETURN_SCHEME_KEY);
      navigate("/dashboard", { replace: true });
    }
  };

  return <MFAPage onSuccess={handleSuccess} />;
};
